import React from 'react'
import { Button, FormFieldSet, Modal } from '../../../../../components'

const VideoInterviewAddAccountModal = ({showAddAccountModal,setShowAddAccountModal}) => {
  return (
    <Modal
        title="Add Account"
        isOpen={showAddAccountModal}
        onClose={() => setShowAddAccountModal(false)}
        width="max-w-4xl"
        titleColor={"primary"}
      >
        <div className=" p-5 shadow-md">
          <div className="grid grid-cols-3 gap-3">
            <FormFieldSet
              type="text"
              placeholder="Display Name"
              title="Display Name"
            />
            <FormFieldSet
              type="text"
              placeholder="Account ID"
              title="Account ID"
            />
            <FormFieldSet
              type="text"
              placeholder="API Client"
              title="API Client"
            />
            <FormFieldSet
              type="text"
              placeholder="API Secret"
              title="API Secret"
            />
            <FormFieldSet type="text" placeholder="Status" title="Status" />
          </div>
          <div className="flex justify-end items-center gap-3 mt-10">
            <Button
              variant="outlined"
              title={"Cancel"}
              onClick={() => setShowAddAccountModal(false)}
            />
            <Button title={"Save"} />
          </div>
        </div>
      </Modal>
  )
}

export default VideoInterviewAddAccountModal
